module.exports = __webpack_public_path__ + "img/3.fa510ad1.png";